export const NR_CONNECTS_TO_LOAD = 8;